export default __webpack_public_path__ + "static/media/flag_ES-ES.40542097.png";